import { WorkspaceStatus } from 'types';
import { ComposerTranslation } from 'vue-i18n';
import z from 'zod';

export const workspaceFormValidator = (t: ComposerTranslation) =>
  z
    .object({
      name: z.string().min(1),
      location: z
        .string()
        .min(1, t('workspaceForm.errors.locationRequired'))
        .max(100),
      durationStart: z.date().refine((val) => val !== null, {
        message: t('workspaceForm.errors.startDateRequired'),
      }),
      durationEnd: z.date().refine((val) => val !== null, {
        message: t('workspaceForm.errors.endDateRequired'),
      }),

      status: z.nativeEnum(WorkspaceStatus).optional(),
    })
    .superRefine(({ durationStart, durationEnd }, ctx) => {
      if (durationStart > durationEnd) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['durationStart'],
          message: t(`workspaceForm.errors.startDate`),
        });
      }
    });
